import { v4 as uuid } from 'uuid';
import SendStepComponentView from './SendStepComponentView.html';
import './SendStepComponent.scss';
import { GROWTH_ACTIVE_MESSAGE_WA_SEND_STEP_ACTIVE_MESSAGE_SCHEDULED_BUTTON_CLICKED, GROWTH_ACTIVE_MESSAGE_WA_SEND_STEP_ACTIVE_MESSAGE_SENT_BUTTON_CLICKED, } from '../../../GrowthSegmentEvents';
import { ActiveMessagesFeatures } from '../../ActiveMessagesFeatures';
import { ToastType } from 'modules/application/misc/ToastService';
import { isNullOrWhiteSpace } from 'data/string';
import { validateScheduledDate } from '../../utils/campaignScheduleUtils';
import { RedirectType } from '../../models/RedirectType';
class SendStepComponentController {
    static $inject = ['$translate', 'AlertService', 'BlipToastService'];
    constructor($translate, AlertService, BlipToastService) {
        'ngInject';
        this.$translate = $translate;
        this.AlertService = AlertService;
        this.BlipToastService = BlipToastService;
        this.isNewCampaignListingActive = ActiveMessagesFeatures.newCampaignListingActiveDefaultValue;
        this.isScheduledCampaign = false;
        this.setScheduleButtonCampaign = (event) => {
            if (event.detail?.checked) {
                if (event.target?.id == 'instant-button') {
                    this.isScheduledCampaign = false;
                }
                else if (event.target?.id == 'scheduled-button') {
                    this.isScheduledCampaign = true;
                }
            }
        };
        this.setScheduleTime = (event) => {
            this.scheduleTime = event.detail?.value;
        };
        this.setScheduleData = (event) => {
            this.scheduleDate = event.detail?.value;
        };
        this.localStorage = window.localStorage;
    }
    async $onInit() {
        this.isScheduledCampaign = false;
        this.isNewCampaignListingActive = await ActiveMessagesFeatures.isNewCampaignListingActive();
        const today = new Date();
        this.scheduleDate = this.addZero(today.getFullYear()) + '-' + this.addZero(today.getMonth() + 1) + '-' + this.addZero(today.getDate());
        this.scheduleTime = this.addZero(today.getHours()) + ':' + this.addZero(today.getMinutes());
    }
    $onChanges() {
        if (this.data) {
            this.steps = JSON.parse(this.data);
        }
    }
    callback($data) {
        this.redirect({ $data });
    }
    finishFlow() {
        this.validateCampaignNameAndFinalize(this.name, () => { this.finishFlow(); }, undefined, GROWTH_ACTIVE_MESSAGE_WA_SEND_STEP_ACTIVE_MESSAGE_SENT_BUTTON_CLICKED);
    }
    finishFlowSchedulingCampaign() {
        if (!this.setInformedDateAndValidateScheduling()) {
            return;
        }
        this.validateCampaignNameAndFinalize(this.name, () => { this.finishFlowSchedulingCampaign(); }, this.informedDate, GROWTH_ACTIVE_MESSAGE_WA_SEND_STEP_ACTIVE_MESSAGE_SCHEDULED_BUTTON_CLICKED);
    }
    async showToast(title, message) {
        this.BlipToastService.show(ToastType.Danger, {
            title: await this.$translate(title),
            msg: await this.$translate(message),
        });
    }
    handlePreviousStep() {
        this.previous();
    }
    async toggleVariablesAlert(confirmButtonActionFunction) {
        const alertTitle = await this.$translate('activeMessages.send.send.alert.title');
        const alertBody = await this.$translate('activeMessages.send.send.alert.body');
        const confirmButton = await this.$translate('activeMessages.send.send.alert.continueButton');
        const cancelButton = await this.$translate('activeMessages.send.send.alert.returnButton');
        await this.AlertService.show({
            title: alertTitle,
            body: alertBody + this.name,
            variant: 'warning',
            icon: 'attention',
            buttons: {
                cancel: cancelButton,
                confirm: confirmButton,
            },
            callback: {
                cancelButtonAction: () => this.focusCampaignName(),
                confirmButtonAction: confirmButtonActionFunction,
            },
        });
    }
    focusCampaignName() {
        const campaignName = document.getElementById('campaignName');
        campaignName.focus();
    }
    validateCampaignNameAndFinalize(campaignName, callbackConfirmButton, $schedule, trackerName) {
        const $data = campaignName;
        const $trackingFunction = () => this.generateNewCampaignTrack(trackerName, campaignName);
        if (!this.name || this.name.length == 0) {
            this.name = `campaign-name-${uuid()}`;
            this.toggleVariablesAlert(callbackConfirmButton);
        }
        else {
            this.finish({ $data, $schedule, $trackingFunction });
        }
    }
    generateNewCampaignTrack(trackerName, campaignName) {
        const validLines = this.steps[0].fileSummary ? this.steps[0].fileSummary.linesCount - this.steps[0].fileSummary.linesErrorsCount : undefined;
        const country = this.steps[0] && this.steps[0].params && this.steps[0].params.countryNumber
            ? this.steps[0].params.countryNumber : '';
        const contentWithLanguage = this.steps[1] && this.steps[1].value
            ? this.steps[1].value[0].description.split(' • ') : undefined;
        const content = contentWithLanguage && contentWithLanguage[0]
            ? contentWithLanguage[0] : '';
        const language = contentWithLanguage && contentWithLanguage[1]
            ? contentWithLanguage[1] : '';
        return {
            trackerName, tracker: {
                activeMessageType: this.steps[0].campaignType,
                applicationOrigin: this.steps[0].applicationOrigin,
                flow: this.steps[2] && this.steps[2].value ? this.steps[2].value[0].description : '',
                content: content,
                country: country,
                language: language,
                messageVolume: validLines,
                shippingType: this.isScheduledCampaign === false ? 'Now' : 'Scheduled',
                action: 'create',
                campaignName: campaignName,
                scheduleDate: this.isScheduledCampaign ? this.informedDate : undefined,
                scheduleTime: this.isScheduledCampaign ? this.scheduleTime : undefined,
                redirectType: this.steps[2]?.params?.attendanceRedirect ? RedirectType.Agent : RedirectType.Flow,
                agentName: this.steps[2]?.params?.attendanceRedirect ?? '',
                stateId: this.steps[2]?.params?.stateId ?? '',
                status: undefined,
                errorMessage: undefined,
            },
        };
    }
    setInformedDateAndValidateScheduling() {
        if (!isNullOrWhiteSpace(this.scheduleDate) && !isNullOrWhiteSpace(this.scheduleTime)) {
            this.informedDate = new Date(this.scheduleDate + ' ' + this.scheduleTime);
        }
        return validateScheduledDate(this.scheduleDate, this.scheduleTime, this.BlipToastService, this.$translate);
    }
    addZero(nbr) {
        return nbr > 9 ? nbr : ('0' + nbr);
    }
}
SendStepComponentController.$inject = ['$translate', 'AlertService', 'BlipToastService'];
export const SendStep = {
    template: SendStepComponentView,
    controller: SendStepComponentController,
    controllerAs: '$ctrl',
    bindings: {
        step: '@?',
        finish: '&?',
        previous: '&?',
        data: '@?',
        redirect: '&?',
        name: '@?',
    },
};
